import React from "react";
import WorkApi from "./WorkApi";
import Navbar from "./Navbar";
export default function HowItWorks() {
  return (
    <>
    <Navbar/>
      <section>
        <div className="work-container container">
          <h1 className="main-heading text-center">How does it work?</h1>
          <div className="row">
            {WorkApi.map(function (curEl) {
              return (
                <>
                  <div className="col-12 col-lg-4  text-center how-does-it-work work-container sub-div">
                    <i
                      style={{ "margin-bottom": "1rem", "font-size": "4rem" }}
                      class={curEl.logo}
                    ></i>
                    <h2 className="sub-heading">{curEl.title}</h2>
                    <p className="main-hero-para w-100">{curEl.info}</p>
                  </div>
                </>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
